import { createLocaleApi } from "@soft-db/simple-i18n";

type UILocale = {
	or: string;
	selected: string;
	selectedPlural: string;
	"table.all": string;
	"table.clearAll": string;
	"table.filter": string;
	"table.filterPlural": string;
	"table.search": string;
	"table.rows-per-page": string;
	"table.page": string;
	"table.of": string;
	"table.no-data-available": string;
	"table.no-result": string;
	"table.clear-filters": string;
	close: string;
	"confirm.yes": string;
	"confirm.no": string;
	"confirm.ok": string;
	"confirm.cancel": string;
	"confirm.delete": string;
};

export type SupportedLang = "en" | "fr";

const locale = {
	en: {
		or: "or",
		selected: "Selected",
		selectedPlural: "Selected",
		"table.all": "All",
		"table.clearAll": "Clear All",
		"table.filter": "Filter",
		"table.filterPlural": "Filters",
		"table.search": "Search",
		"table.rows-per-page": "Rows per page",
		"table.page": "Page",
		"table.of": "of",
		"table.no-data-available": "No data available",
		"table.no-result": "No result found.",
		"table.clear-filters": "Clear filters",
		close: "Close",
		"confirm.yes": "Yes",
		"confirm.no": "No",
		"confirm.ok": "OK",
		"confirm.cancel": "Cancel",
		"confirm.delete": "Delete",
	},
	fr: {
		or: "ou",
		selected: "Sélectionné",
		selectedPlural: "Sélectionnés",
		"table.all": "Tous",
		"table.clearAll": "Réinitialiser",
		"table.filter": "Filtre",
		"table.filterPlural": "Filtres",
		"table.search": "Chercher",
		"table.rows-per-page": "Lignes par page",
		"table.page": "Page",
		"table.of": "de",
		"table.no-data-available": "Aucune donnée disponible",
		"table.no-result": "Aucun résultat trouvé",
		"table.clear-filters": "Retirer les filtres",
		close: "Fermer",
		"confirm.yes": "Oui",
		"confirm.no": "Non",
		"confirm.ok": "OK",
		"confirm.cancel": "Annuler",
		"confirm.delete": "Supprimer",
	},
} as const satisfies Record<SupportedLang, UILocale>;

export const { useLocale, createLocale } = createLocaleApi(locale, "en");
